<form #logoutForm ngNoForm [action]="logoutUrl" method="post"></form>
